import React from 'react';
import { FaEdit } from '@react-icons/all-files/fa/FaEdit';
import { FaTrash } from '@react-icons/all-files/fa/FaTrash';
import { FaDraftingCompass } from '@react-icons/all-files/fa/FaDraftingCompass';
import { FaNetworkWired } from '@react-icons/all-files/fa/FaNetworkWired';
import { FaLink } from '@react-icons/all-files/fa/FaLink';
import { FaDotCircle } from '@react-icons/all-files/fa/FaDotCircle';

// ── EditButton ─────────────────────────────────────────────────────────────

interface EditButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
}

export function EditButton({ onClick, title = 'Editar', disabled, icon }: EditButtonProps) {
  return (
    <button style={s.edit} title={title} onClick={onClick} disabled={disabled}>
      {icon ?? <FaEdit />}
    </button>
  );
}

// ── DeleteButton ───────────────────────────────────────────────────────────

interface DeleteButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
}

export function DeleteButton({ onClick, title = 'Eliminar', disabled, icon }: DeleteButtonProps) {
  return (
    <button style={s.delete} title={title} onClick={onClick} disabled={disabled}>
      {icon ?? <FaTrash />}
    </button>
  );
}

// ── DesignButton ───────────────────────────────────────────────────────────

interface DesignButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
}

export function DesignButton({ onClick, title = 'Diseño', disabled, icon }: DesignButtonProps) {
  return (
    <button style={s.design} title={title} onClick={onClick} disabled={disabled}>
      {icon ?? <FaDraftingCompass />}
    </button>
  );
}

export function WorkflowEmpresaButton({ onClick, title = 'Workflow Empresa', disabled, icon }: DesignButtonProps) {
  return (
    <button style={s.workflowEmpresa} title={title} onClick={onClick} disabled={disabled}>
      {icon ?? <FaNetworkWired />}
    </button>
  );
}

export function WorkflowEmpresaActividadButton({ onClick, title = 'Workflow Empresa', disabled, icon }: DesignButtonProps) {
  return (
    <button style={s.workflowEmpresaActividad} title={title} onClick={onClick} disabled={disabled}>
      {icon ?? <FaLink />}
    </button>
  );
}


export function WorkflowInstanciaNodoButton({ onClick, title = 'Workflow Instancia Nodos', disabled, icon }: DesignButtonProps) {
  return (
    <button style={s.workflowInstanciaNodo} title={title} onClick={onClick} disabled={disabled}>
      {icon ?? <FaDotCircle />}
    </button>
  );
}

// ── RenderActions ──────────────────────────────────────────────────────────

interface RenderActionsProps {
  children: React.ReactNode;
  gap?: number;
}

export function RenderActions({ children, gap = 6 }: RenderActionsProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap }}>
      {children}
    </div>
  );
}

// ── Styles ─────────────────────────────────────────────────────────────────

const s: Record<string, React.CSSProperties> = {
  edit: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    width: 30, height: 30, border: '1px solid #e2e8f0', borderRadius: 6,
    background: '#f8fafc', color: '#3b82f6', cursor: 'pointer', fontSize: 13,
    padding: 0,
  },
  delete: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    width: 30, height: 30, border: '1px solid #fee2e2', borderRadius: 6,
    background: '#fff5f5', color: '#ef4444', cursor: 'pointer', fontSize: 13,
    padding: 0,
  },
  design: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    width: 30, height: 30, border: '1px solid #ddd6fe', borderRadius: 6,
    background: '#f5f3ff', color: '#7c3aed', cursor: 'pointer', fontSize: 13,
    padding: 0,
  },
  workflowEmpresa: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    width: 30, height: 30, border: '1px solid #ddd6fe', borderRadius: 6,
    background: '#f5f3ff', color: '#14b8a6', cursor: 'pointer', fontSize: 13,
    padding: 0,
  },
  workflowEmpresaActividad: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    width: 30, height: 30, border: '1px solid #ddd6fe', borderRadius: 6,
    background: '#f5f3ff', color: '#14b8a6', cursor: 'pointer', fontSize: 13,
    padding: 0,
  },
  workflowInstanciaNodo: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    width: 30, height: 30, border: '1px solid #ddd6fe', borderRadius: 6,
    background: '#f5f3ff', color: '#ef4444', cursor: 'pointer', fontSize: 13,
    padding: 0,
  },
};
